import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ConnectAppsService } from '../../../profile/group-settings/group-settings-panel/connected-apps/services/connect-apps.service';
import { Addon } from '../../models/addon.model';
import { TildaService } from '../../services/tilda.service';
import { TildaProject } from '../../models/tilda-project.model';

@Component({
  templateUrl: './tilda-projects-dialog.component.html',
  styleUrls: ['./tilda-projects-dialog.component.scss']
})
export class TildaProjectsDialogComponent implements OnInit, OnDestroy {
  loading: boolean;
  items: { id: string, title: string, description?: string }[] = []
  searchedItems: { id: string, projectid?: string, title: string, description?: string }[] = []
  selectedItem: { id: string, projectid?: string, title: string, description?: string };
  projectSelected: boolean = false;
  private _subs: SubSink = new SubSink();
  private searchDecouncer$: Subject<string> = new Subject();
  title: string;
  constructor(
    private connectAppsService: ConnectAppsService,
    private tildaService: TildaService,
    private dialogRef: MatDialogRef<TildaProjectsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      tildaAddon: Addon,
      selectedProjectId: string,
      selectedPageId: string
    }
  ) {
    this.title = 'CustomTabsPage.SelectProject';

  }

  ngOnInit(): void {
    this.setupSearchDebouncer();
    this.initTilda();
  }

  initTilda() {
    this.projectSelected = false;
    this.loading = true;
    this.connectAppsService.getTildaOrganizations(
      this.data.tildaAddon.Configuration.publickey,
      this.data.tildaAddon.Configuration.secretkey).pipe(
        map(response => {
          return response['result'] ?? [];
        }),
        finalize(() => {
          this.loading = false;
        })).subscribe((res: TildaProject[]) => {
          if (res) {
            this.searchedItems = res;
            this.items = this.searchedItems;
            if (this.data?.selectedProjectId) {
              this.selectedItem = this.searchedItems.find(it => it.id == this.data.selectedProjectId);
            }
          }
        });
  }


  isSelected(itemId): boolean {
    if (this.selectedItem) {
      return this.selectedItem.id == itemId;
    }
    return false;
  }

  onRadioBtnChange(event: MatRadioChange) {
    const itemId = event.source.value;
    const item = this.searchedItems.find(i => i.id == itemId);
    this.selectedItem = item;
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  onSearchInputChange(event: any) {
    this.searchDecouncer$.next(event)
  }

  private setupSearchDebouncer(): void {
    this.searchDecouncer$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe((term: string) => {
      this.search(term);
    });
  }

  private search(term: string): void {
    if (term.length) {
      this.searchedItems = []
      this.searchedItems = this.items?.filter(it => it?.title?.toLowerCase().includes(term.toLowerCase()));
    } else {
      this.searchedItems = this.items;
    }
  }

  onSubmit() {
    if (this.projectSelected) {
      this.dialogRef.close(this.selectedItem);
    }
    else {
      this.title = 'CustomTabsPage.SelectPage';
      this.loading = true;
      this.projectSelected = true;
      this.tildaService.getProjectPages(this.data.tildaAddon.Configuration.publickey,
        this.data.tildaAddon.Configuration.secretkey, this.selectedItem.id).pipe(finalize(() => {
          this.loading = false;
        })).subscribe(res => {
          if (res) {
            this.items = [];
            res.map(pp => {
              let _item = {
                id: pp.id,
                title: pp.title,
                projectid: pp.projectid,
                descr: pp.descr
              }
              this.items.push(_item);
            })
            this.searchedItems = this.items;
            if (this.data?.selectedPageId) {
              this.selectedItem = this.searchedItems.find(it => it.id == this.data.selectedPageId);
            } else {
              this.selectedItem = null;
            }
          }
        });
    }
  }

}
